export default __webpack_public_path__ + "static/media/icon-company.6f78ffb3.svg";